import { render, staticRenderFns } from "./NbSupervisorToolbar.vue?vue&type=template&id=36257788"
import script from "./NbSupervisorToolbar.vue?vue&type=script&lang=js"
export * from "./NbSupervisorToolbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports